import { File } from "./file";
export class Photo {
    constructor() {
        this.id = null;
        this.entityId = null;
        this.order = 0;
        this.originalFileId = null;
        this.originalFile = null;
        this.dateAdded = null;
        this.updatedAt = null;
        this.updatedBy = null;
        this.createdBy = null;
    }
    static load(source) {
        const photo = new Photo();
        photo.id = source.id;
        photo.entityId = source.entityId;
        photo.order = source.order;
        photo.originalFileId = source.originalFileId;
        photo.originalFile = source.originalFile ? File.load(source.originalFile) : null;
        photo.dateAdded = source.dateAdded;
        photo.updatedAt = source.updatedAt;
        photo.updatedBy = source.updatedBy;
        photo.createdBy = source.createdBy;
        return photo;
    }
}
//# sourceMappingURL=photo.js.map